module.exports = __webpack_public_path__ + "media/images/icons/ic-events-002356c983fe8d5cf9c267cb07e2c1d5.svg";